<div class="agpr-includeExclude-container">
    <div
        *ngIf="headerLabel"
        class="agpr-includeExclude-headerLabelContainer"
    >
        <agpr-button
            class="agpr-includeExclude-expandButton"
            [style]="buttonTypes.link"
            [icon]="
                expanded ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-right'
            "
            [disabled]="
                expanded &&
                (value?.exclude?.length > 0 || value?.includeAll?.length > 0)
            "
            [expanded]="expanded"
            (click)="toggleExpanded()"
            [ariaLabel]="tooltip ?
                ((headerLabel | localize) + '. ' + ('Discover.targeting.searchFieldLabels.expandButton.tooltip' | localize) + '. ' + ('tooltipDetails' | localize))
                : ((headerLabel | localize) + '. ' + ('Discover.targeting.searchFieldLabels.expandButton.tooltip' | localize))"
        >
            <span
                [id]="id + '.label'"
                class="agpr-includeExclude-headerLabel"
            >
                {{ headerLabel | localize }}
            </span>
        </agpr-button>
        <span
            *ngIf="tooltip"
            role="img"
            class="agpr-includeExclude-infoIconStyle fa-regular fa-circle-info"
            [agprTooltip]="tooltip"
            tooltipPosition="top"
            tabindex="0"
        ></span>
    </div>
    <div
        class="agpr-includeExclude-chipsContainer"
        role="group"
        [attr.aria-labelledby]="id + '.label'"
        [attr.aria-describedby]="ariaDescribedBy"
    >
        <div class="agpr-includeExclude-chipRow">
            <label
                *ngIf="!isAutoComplete && !isDropdown"
                [id]="id + '_includeChips_orLabel'"
                [for]="id + '.includeChips'"
                [@labelState]="expanded ? 'visible' : 'hidden'"
            >
                ({{'or' | localize}})
            </label>
            <agpr-text-input-chips
                *ngIf="value && !isAutoComplete && !isDropdown"
                [id]="id + '.includeChips'"
                [chipValidations]="chipValidations"
                [placeholder]="placeholder | localize"
                [style]="style"
                [disabled]="disabled"
                [splitOnPattern]="splitOnPattern"
                [ariaLabelledBy]="id + '_includeChips_orLabel'"
                [ngModel]="value.include"
                [trimQuotes]="true"
                (ngModelChange)="handleChanges(includeOrExclude.include, $event)"
                (blur)="onBlur($event)"
            ></agpr-text-input-chips>
            <label
                *ngIf="isAutoComplete"
                [id]="id + '_includeChips_autocomplete_orLabel'"
                [for]="id + '.includeChips.autocomplete'"
                [@labelState]="expanded ? 'visible' : 'hidden'"
            >
                ({{'or' | localize}})
            </label>
            <agpr-autocomplete-chips
                *ngIf="value && isAutoComplete"
                [id]="id + '.includeChips'"
                [placeholder]="placeholder | localize"
                [field]="labelLookupField"
                [autocompleteOptions]="autocompleteOptions"
                [disabled]="disabled"
                [button]="showBrowseAll ? browseAllButtonSpec : null"
                [ariaLabelledBy]="id + '_includeChips_autocomplete_orLabel'"
                [ngModel]="value.include"
                (ngModelChange)="handleChanges(includeOrExclude.include, $event)"
                (buttonPress)="browseAll.emit(includeOrExclude.include)"
                (blur)="onBlur($event)"
            ></agpr-autocomplete-chips>
            <label
                *ngIf="isDropdown"
                [id]="id + 'includeChips_dropdown_orLabel'"
                [@labelState]="expanded ? 'visible' : 'hidden'"
            >
                ({{'or' | localize}})
            </label>
            <agpr-multi-select-dropdown
                *ngIf="value && isDropdown"
                [id]="id + '.includeChips'"
                [placeholder]="placeholder | localize"
                [optionsFetcher]="optionsFetcher"
                [labelLookupField]="labelLookupField"
                [keyLookupField]="keyLookupField"
                [tooltipPath]="tooltipPath"
                [tooltipPosition]="itemTooltipPosition"
                [ariaLabelledBy]="id + 'includeChips_dropdown_orLabel'"
                [ngModel]="value.include"
                (ngModelChange)="handleChanges(includeOrExclude.include, $event)"
                (blur)="onBlur($event)"
            ></agpr-multi-select-dropdown>
        </div>

        <div
            *ngIf="expanded"
            @containerState
            class="agpr-includeExclude-chipsContainer--expanded"
        >
            <ng-container *ngIf="showIncludeAll">
                <div class="agpr-includeExclude-chipRow">
                    <label
                        *ngIf="!isAutoComplete && !isDropdown"
                        [id]="id + '_includeAllChips_andLabel'"
                        class="agpr-includeExclude-chipRow-expandedLabel"
                    >
                        ({{'and' | localize}})
                    </label>
                    <agpr-text-input-chips
                        *ngIf="value && !isAutoComplete && !isDropdown"
                        [id]="id + '.includeAllChips'"
                        [placeholder]="placeholder | localize"
                        [disabled]="disabled"
                        [chipValidations]="chipValidations"
                        [style]="style"
                        [splitOnPattern]="splitOnPattern"
                        [trimQuotes]="true"
                        [ariaLabelledBy]="id + '_includeAllChips_andLabel'"
                        [ngModel]="value.includeAll"
                        (ngModelChange)="
                            handleChanges(includeOrExclude.includeAll, $event)
                        "
                    ></agpr-text-input-chips>
                    <label
                        *ngIf="isAutoComplete"
                        [id]="id + '_includeAllChips_autocomplete_andLabel'"
                        [for]="id + '.includeAllChips.autocomplete'"
                        class="agpr-includeExclude-chipRow-expandedLabel"
                    >
                        ({{'and' | localize}})
                    </label>
                    <agpr-autocomplete-chips
                        *ngIf="value && isAutoComplete"
                        [id]="id + '.includeAllChips'"
                        [placeholder]="placeholder | localize"
                        [field]="labelLookupField"
                        [autocompleteOptions]="autocompleteOptions"
                        [disabled]="disabled"
                        [ngModel]="value.includeAll"
                        (ngModelChange)="
                            handleChanges(includeOrExclude.includeAll, $event)
                        "
                        [button]="showBrowseAll ? browseAllButtonSpec : null"
                        [ariaLabelledBy]="id + '_includeAllChips_autocomplete_andLabel'"
                        (buttonPress)="browseAll.emit(includeOrExclude.includeAll)"
                    ></agpr-autocomplete-chips>
                    <label
                        *ngIf="isDropdown"
                        [id]="id + '_includeAllChips_dropdown_andLabel'"
                        class="agpr-includeExclude-chipRow-expandedLabel"
                    >
                        ({{'and' | localize}})
                    </label>
                    <agpr-multi-select-dropdown
                        *ngIf="value && isDropdown"
                        [id]="id + '.includeAllChips'"
                        [placeholder]="placeholder | localize"
                        [optionsFetcher]="optionsFetcher"
                        [labelLookupField]="labelLookupField"
                        [keyLookupField]="keyLookupField"
                        [tooltipPath]="tooltipPath"
                        [tooltipPosition]="itemTooltipPosition"
                        [ariaLabelledBy]="id + '_includeAllChips_dropdown_andLabel'"
                        [ngModel]="value.includeAll"
                        (ngModelChange)="handleChanges(includeOrExclude.includeAll, $event)"
                    ></agpr-multi-select-dropdown>
                </div>
            </ng-container>
            <div *ngIf="showIncludeAll" class="agpr-includeExclude-chipsContainer--expanded-divider"></div>
            <div class="agpr-includeExclude-chipRow">
                <label
                    *ngIf="!isAutoComplete && !isDropdown"
                    [id]="id + '_excludeChips_notLabel'"
                    class="agpr-includeExclude-chipRow-expandedLabel"
                >
                    ({{'not' | localize}})
                </label>
                <agpr-text-input-chips
                    *ngIf="value && !isAutoComplete && !isDropdown"
                    [id]="id + '.excludeChips'"
                    [placeholder]="placeholder | localize"
                    [chipValidations]="chipValidations"
                    [disabled]="disabled"
                    [style]="style"
                    [splitOnPattern]="splitOnPattern"
                    [trimQuotes]="true"
                    [ariaLabelledBy]="id + '_excludeChips_notLabel'"
                    [ngModel]="value.exclude"
                    (ngModelChange)="
                        handleChanges(includeOrExclude.exclude, $event)
                    "
                    (blur)="onBlur($event)"
                ></agpr-text-input-chips>
                <label
                    *ngIf="isAutoComplete"
                    [id]="id + '_excludeChips_autocomplete_notLabel'"
                    [for]="id + '.excludeChips.autocomplete'"
                    class="agpr-includeExclude-chipRow-expandedLabel"
                >
                    ({{'not' | localize}})
                </label>
                <agpr-autocomplete-chips
                    *ngIf="value && isAutoComplete"
                    [id]="id + '.excludeChips'"
                    [placeholder]="placeholder | localize"
                    [field]="labelLookupField"
                    [autocompleteOptions]="autocompleteOptions"
                    [disabled]="disabled"
                    [ariaLabelledBy]="id + '_excludeChips_autocomplete_notLabel'"
                    [ngModel]="value.exclude"
                    (ngModelChange)="
                        handleChanges(includeOrExclude.exclude, $event)
                    "
                    [button]="showBrowseAll ? browseAllButtonSpec : null"
                    (buttonPress)="browseAll.emit(includeOrExclude.exclude)"
                    (blur)="onBlur($event)"
                ></agpr-autocomplete-chips>
                <label
                    *ngIf="isDropdown"
                    [id]="id + '.excludeChips_dropdown_notLabel'"
                    class="agpr-includeExclude-chipRow-expandedLabel"
                >
                    ({{'not' | localize}})
                </label>
                <agpr-multi-select-dropdown
                    *ngIf="value && isDropdown"
                    [id]="id + '.excludeChips'"
                    [placeholder]="placeholder | localize"
                    [optionsFetcher]="optionsFetcher"
                    [labelLookupField]="labelLookupField"
                    [keyLookupField]="keyLookupField"
                    [tooltipPath]="tooltipPath"
                    [tooltipPosition]="itemTooltipPosition"
                    [ariaLabelledBy]="id + '.excludeChips_dropdown_notLabel'"
                    [ngModel]="value.exclude"
                    (ngModelChange)="handleChanges(includeOrExclude.exclude, $event)"
                    (blur)="onBlur($event)"
                ></agpr-multi-select-dropdown>
            </div>
        </div>
    </div>
</div>
